module.exports = __webpack_public_path__ + "media/partenaire/underline-daf56789.svg";